/**
 * Router for Hylyght
 */
import { HylyghtInjectedPage } from './pages/HylyghtInjected.page'

import type { RouteObject } from 'react-router-dom'

const hylyghtRoutes: RouteObject[] = [
  {
    path: 'hylyght',
    element: <HylyghtInjectedPage />,
  },
]

export { hylyghtRoutes }
